import React from "react";

/**
 * Renders page copy with `**bold**` markers (the highlighted keywords from
 * the landing-page documents) as <strong>. Everything else stays plain
 * text, so copy can't inject markup.
 */
export default function RichText({
  text,
  strongClassName = "font-semibold",
}: {
  text: string;
  strongClassName?: string;
}): React.ReactNode {
  return text.split(/\*\*(.+?)\*\*/g).map((part, i) =>
    i % 2 === 1 ? (
      <strong key={i} className={strongClassName}>
        {part}
      </strong>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    ),
  );
}

/** The copy without bold markers, for alt text, keys and JSON-LD. */
export const plainText = (text: string) => text.replace(/\*\*/g, "");
